module.exports = __webpack_public_path__ + "img/sign.42510c2b.png";